import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Paper,
  Typography,
  makeStyles,
} from "@material-ui/core";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import CloseIcon from "@material-ui/icons/Close";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

// Images are stored in public/images/saparya/ and referenced via absolute paths
// Add more images to the public/images/saparya/ folder and list them here
const SAPARYA_IMAGES = [
  "/images/saparya/WhatsApp Image 2026-01-28 at 12.07.22 PM.jpeg", 
  "/images/saparya/WhatsApp Image 2026-01-28 at 12.07.22 PM (1).jpeg",     // Image 3: Man with lanyard
  "/images/saparya/WhatsApp Image 2026-01-28 at 12.07.22 PM (2).jpeg",
  "/images/saparya/WhatsApp Image 2026-01-28 at 12.07.21 PM.jpeg",        // Image 1: Conference hall
        // Image 2: Woman at entrance
      // Image 4: Audience with screen
];

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(7, 2),
    background: "linear-gradient(135deg, #f0f7ff 0%, #fff6ea 100%)",
  },
  container: {
    maxWidth: 1100,
    margin: "0 auto",
  },
  card: {
    borderRadius: 18,
    overflow: "hidden",
    border: "1px solid #e5e7eb",
    boxShadow: "0 10px 30px rgba(37, 99, 235, 0.08)",
  },
  cardInner: {
    display: "grid",
    gridTemplateColumns: "1.2fr 1fr",
    gap: theme.spacing(3),
    padding: theme.spacing(3),
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
  badgeRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  badge: {
    fontSize: 12,
    padding: "6px 10px",
    borderRadius: 999,
    background: "rgba(37, 99, 235, 0.10)",
    color: "#1d4ed8",
    border: "1px solid rgba(37, 99, 235, 0.15)",
    fontWeight: 600,
  },
  badgeAlt: {
    background: "rgba(249, 115, 22, 0.12)",
    color: "#c2410c",
    border: "1px solid rgba(249, 115, 22, 0.18)",
  },
  actionsRow: {
    display: "flex",
    gap: theme.spacing(1.5),
    flexWrap: "wrap",
    alignItems: "center",
    marginTop: theme.spacing(2),
  },
  preview: {
    borderRadius: 16,
    minHeight: 170,
    height: 210,
    background:
      "radial-gradient(80% 80% at 20% 10%, rgba(37,99,235,0.22) 0%, rgba(255,255,255,0) 60%), radial-gradient(90% 90% at 90% 80%, rgba(249,115,22,0.20) 0%, rgba(255,255,255,0) 55%), #ffffff",
    border: "1px solid #e5e7eb",
    overflow: "hidden",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  previewImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
  placeholder: {
    textAlign: "center",
    padding: theme.spacing(4),
    color: "#374151",
  },
  dialogPaper: {
    borderRadius: 16,
  },
  dialogHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    padding: theme.spacing(2, 2, 0, 2),
  },
  viewer: {
    position: "relative",
    borderRadius: 14,
    overflow: "hidden",
    background: "#0b1220",
    border: "1px solid rgba(255,255,255,0.08)",
  },
  viewerImg: {
    width: "100%",
    maxHeight: "55vh",
    objectFit: "contain",
    display: "block",
    background: "#0b1220",
  },
  navBtn: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    background: "rgba(255,255,255,0.14)",
    color: "white",
    backdropFilter: "blur(6px)",
    border: "1px solid rgba(255,255,255,0.18)",
  },
  navLeft: { left: 10 },
  navRight: { right: 10 },
  thumbs: {
    display: "flex",
    gap: theme.spacing(1),
    overflowX: "auto",
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(0.5),
  },
  thumb: {
    width: 72,
    height: 52,
    borderRadius: 10,
    border: "2px solid transparent",
    overflow: "hidden",
    cursor: "pointer",
    flex: "0 0 auto",
    opacity: 0.85,
    "&:hover": { opacity: 1 },
  },
  thumbActive: {
    borderColor: "#2563eb",
    opacity: 1,
  },
  thumbImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
}));

export default function SaparyaConferenceSection() {
  const classes = useStyles();

  const images = SAPARYA_IMAGES;
  const hasImages = images.length > 0;

  const [open, setOpen] = React.useState(false);
  const [activeIdx, setActiveIdx] = React.useState(0);

  const openViewer = () => {
    setActiveIdx(0);
    setOpen(true);
  };

  const closeViewer = () => setOpen(false);

  const goPrev = () => setActiveIdx((i) => (i - 1 + images.length) % images.length);
  const goNext = () => setActiveIdx((i) => (i + 1) % images.length);

  const activeImage = hasImages ? images[activeIdx] : null;

  return (
    <Box className={classes.root}>
      <Box className={classes.container}>
        <Paper className={classes.card} elevation={0}>
          <Box className={classes.cardInner}>
            <Box>
              <Typography variant="h5" style={{ fontWeight: 800, color: "#111827" }}>
                “Saparya” — 7th AMI National Conference, Mumbai
              </Typography>

              <Box className={classes.badgeRow}>
                <span className={classes.badge}>Saparya</span>
                <span className={`${classes.badge} ${classes.badgeAlt}`}>7th</span>
                <span className={classes.badge}>AMI</span>
                <span className={`${classes.badge} ${classes.badgeAlt}`}>National Conference</span>
                <span className={classes.badge}>Mumbai</span>
              </Box>

              <Typography variant="body1" style={{ color: "#374151", lineHeight: 1.7 }}>
                Click the link below to view the conference photos in a clean, full‑screen viewer.
              </Typography>

              <Box className={classes.actionsRow}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<PhotoLibraryIcon />}
                  onClick={openViewer}
                  style={{ textTransform: "none", borderRadius: 10 }}
                  disabled={!hasImages}
                >
                  View photos
                </Button>

                {!hasImages && (
                  <Typography variant="caption" style={{ color: "#6b7280" }}>
                    Add images to <b>public/images/saparya/</b> and update the SAPARYA_IMAGES array in the component.
                  </Typography>
                )}
              </Box>
            </Box>

            <Box className={classes.preview}>
              {hasImages ? (
                <img
                  src={images[0]}
                  alt="Saparya conference preview"
                  className={classes.previewImg}
                />
              ) : (
                <Box className={classes.placeholder}>
                  <PhotoLibraryIcon style={{ fontSize: 48, color: "#2563eb" }} />
                  <Typography variant="h6" style={{ fontWeight: 700, marginTop: 10 }}>
                    Saparya photo gallery
                  </Typography>
                  <Typography variant="body2" style={{ marginTop: 6, color: "#6b7280" }}>
                    Images are loaded from <b>public/images/saparya/</b>
                    <br />
                    Add more images there and update the component.
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Paper>
      </Box>

      <Dialog
        open={open}
        onClose={closeViewer}
        fullWidth
        maxWidth="md"
        classes={{ paper: classes.dialogPaper }}
      >
        <Box className={classes.dialogHeader}>
          <Box>
            <Typography variant="h6" style={{ fontWeight: 800 }}>
              “Saparya” — 7th AMI National Conference, Mumbai
            </Typography>
            {hasImages && (
              <Typography variant="caption" style={{ color: "#6b7280" }}>
                Photo {activeIdx + 1} of {images.length}
              </Typography>
            )}
          </Box>
          <IconButton onClick={closeViewer} aria-label="Close">
            <CloseIcon />
          </IconButton>
        </Box>

        <DialogContent style={{ paddingTop: 12 }}>
          {hasImages ? (
            <>
              <Box className={classes.viewer}>
                <img src={activeImage} alt="Saparya conference" className={classes.viewerImg} />

                {images.length > 1 && (
                  <>
                    <IconButton
                      className={`${classes.navBtn} ${classes.navLeft}`}
                      onClick={goPrev}
                      aria-label="Previous photo"
                    >
                      <ChevronLeftIcon />
                    </IconButton>
                    <IconButton
                      className={`${classes.navBtn} ${classes.navRight}`}
                      onClick={goNext}
                      aria-label="Next photo"
                    >
                      <ChevronRightIcon />
                    </IconButton>
                  </>
                )}
              </Box>

              {images.length > 1 && (
                <Box className={classes.thumbs}>
                  {images.map((src, idx) => (
                    <Box
                      key={src}
                      className={`${classes.thumb} ${idx === activeIdx ? classes.thumbActive : ""}`}
                      onClick={() => setActiveIdx(idx)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") setActiveIdx(idx);
                      }}
                      aria-label={`Open photo ${idx + 1}`}
                    >
                      <img src={src} alt={`Saparya thumbnail ${idx + 1}`} className={classes.thumbImg} />
                    </Box>
                  ))}
                </Box>
              )}
            </>
          ) : (
            <Typography variant="body2" color="textSecondary">
              No images found. Add images to <b>public/images/saparya/</b> and update the SAPARYA_IMAGES array.
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}

